import React from 'react';
import ProdutoService from '../services/ProdutoService';
import { Rating } from 'primereact/rating';
import { Button } from 'primereact/button';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';


class Perfil extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            
            
        }
    }

    async componentDidMount(){    
        
        
    }

    render() {
        return(
            <div>
                
            </div>
        );
        
    }


}
export default Perfil;
